import React from 'react'
import ReactDOM from 'react-dom'
import IndividualPrices from './components/IndividualPrices';
import Filters from './components/Filters';


//Supress locales message
// if(process.env.NODE_ENV !== 'production' || window.server_type !== '0') {
// 	const originalConsoleError = console.error
// 	if(console.error === originalConsoleError) {
// 		console.error = (...args) => {
// 			if(args[0].indexOf('[React Intl]') === 0) {
// 				return;
// 			}
// 			originalConsoleError.call(console, ...args)
// 		}
// 	}
// }

var EPWEB = {
	IndividualPrices: function(element, data) {
		if(element == undefined) element = 'root';
		data = data === undefined ? {} : data;
		ReactDOM.render(
			<IndividualPrices {...data}></IndividualPrices>
			,
			document.getElementById(element)
		);
	},

	Filters: function(element, data) {
		if(element == undefined) element = 'root';
		data = data === undefined ? {} : data;
		ReactDOM.render(
			<Filters {...data}></Filters>
			,
			document.getElementById(element)
		);
	}
}
window.EPWEB = EPWEB;
export default EPWEB;
